import { useState, useEffect } from "react";
import { apiClient } from "../../lib/api";
import { LayoutSectionList } from "./LayoutSectionList";
import { LayoutSection } from "../../lib/types";

export function LayoutSections() {
  const [sections, setSections] = useState<LayoutSection[]>([]);
  const [newSection, setNewSection] = useState({
    section_name: "",
    description: "",
    max_images: 1,
    allowed_aspect_ratios: "[]",
  });
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);

  // セクション一覧を取得
  const fetchSections = async () => {
    try {
      const data = await apiClient.get("/layout_sections") as LayoutSection[];
      setSections(data);
    } catch (err: any) {
      setError(err.message);
      setTimeout(() => setError(null), 5000);
    }
  };

  // 新しいセクションを追加
  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    try {
      await apiClient.post("/layout_sections", {
        ...newSection,
        allowed_aspect_ratios: JSON.parse(newSection.allowed_aspect_ratios),
      });

      setSuccess("セクションを追加しました");
      setTimeout(() => setSuccess(null), 3000);

      // フォームをリセット
      setNewSection({
        section_name: "",
        description: "",
        max_images: 1,
        allowed_aspect_ratios: "[]",
      });

      // 一覧を更新
      fetchSections();
    } catch (err: any) {
      setError(err.message);
      setTimeout(() => setError(null), 5000);
    }
  };

  useEffect(() => {
    fetchSections();
  }, []);

  return (
    <div className="p-4">
      <div className="space-y-8">
        {error && (
          <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative">
            {error}
          </div>
        )}
        {success && (
          <div className="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded relative">
            {success}
          </div>
        )}

        {/* 新規セクション追加フォーム */}
        <form
          onSubmit={handleSubmit}
          className="border rounded-md p-4 space-y-4"
        >
          <div className="space-y-2">
            <label className="block text-sm font-medium text-gray-700">
              セクション名 <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              value={newSection.section_name}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                setNewSection({ ...newSection, section_name: e.target.value })
              }
              placeholder="header, main-hero など"
              className="mt-1 p-2 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
              required
            />
          </div>

          <div className="space-y-2">
            <label className="block text-sm font-medium text-gray-700">
              説明
            </label>
            <textarea
              value={newSection.description}
              onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) =>
                setNewSection({ ...newSection, description: e.target.value })
              }
              placeholder="このセクションの説明を入力してください"
              className="mt-1 p-2 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
              rows={3}
            />
          </div>

          <div className="mt-4 flex flex-row gap-4">
            <div className="">
              <label className="block text-sm font-medium text-gray-700">
                最大画像数 <span className="text-red-500">*</span>
              </label>
              <input
                type="number"
                min={1}
                value={newSection.max_images}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  setNewSection({
                    ...newSection,
                    max_images: parseInt(e.target.value),
                  })
                }
                className="mt-1 p-2 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                required
              />
            </div>

            <div className="">
              <label className="block text-sm font-medium text-gray-700">
                許可するアスペクト比（JSON形式）
              </label>
              <input
                type="text"
                value={newSection.allowed_aspect_ratios}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  setNewSection({
                    ...newSection,
                    allowed_aspect_ratios: e.target.value,
                  })
                }
                placeholder='["16:9", "4:3"]'
                className="mt-1 p-2 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
              />
            </div>
          </div>

          <button
            type="submit"
            className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
          >
            セクションを追加
          </button>
        </form>
        <h2 className="text-xl font-semibold text-center text-gray-700">
          登録済みセクション一覧
        </h2>
        {/* セクション一覧 */}
        <LayoutSectionList sections={sections} onUpdate={fetchSections} />
      </div>
    </div>
  );
}
